import React from 'react';
import {
    Div,
    SplitCol,
    SplitLayout,
    Button,
    Search, ModalRoot
} from '@vkontakte/vkui';

import {
    Icon24BrowserBack,
    Icon24Info
} from "@vkontakte/icons";
import {AdaptivityContext, setQuizStep} from "../assets/constants";
import * as constants from "../assets/constants";
import BaseComponent from "../components/BaseComponent";


class FacingMonitoringStepHeader extends BaseComponent {

    state = {
        mainSearch: this.props.search??'',

    }

    constructor(props) {
        super(props);

    }

    receiveMessage = (event) => {
        if (event.data == 'stepPrev') {
            if (this.state.activeModal == null) {
                if (this.props.step > 1) {
                    setQuizStep(this.props.step - 1, 'FacingMonitoring')
                } else {
                    window.postMessage('goToMain')
                }
            } else {
                this.modalBack()
            }
        }
    }

    scrollPrev = 0
    checkToolbarScroll = () => {
        let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

        if (!headerMobStorage || headerMobStorage.length === 0) return

        headerMobStorage = headerMobStorage[0]
        const scrolled = window.scrollY

        if (scrolled > 100 && scrolled > this.scrollPrev) {
            headerMobStorage.classList.add('out')
        } else {
            headerMobStorage.classList.remove('out')
        }
        this.scrollPrev = scrolled
    }


    handleScroll() {
        this.checkToolbarScroll()
    }

    onSearchChange = (e) => {
        this.setState({mainSearch: e.target.value})
        this.props.onSearchChange(e)
    }
   componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if(prevProps.search !== this.props.search){
            this.setState({mainSearch: this.props.search})
        }
   }

    render() {
        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>

            </ModalRoot>
        );

        return (<Div
            className={AdaptivityContext.isMobile ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout modal={modals}
                         _style={{height: AdaptivityContext.isMobile && this.state.activeModal ? AdaptivityContext.h + 'px' : 'inherit'}}
            >

                {this.props.onSearchChange && <SplitCol>
                    <Search theme="header"
                            name="search"
                            autoComplete="off"
                            placeholder="Поиск"
                            value={this.state.mainSearch}
                            onChange={this.onSearchChange}

                            _style={{flexGrow: '1', maxWidth: '350px'}}
                    />
                </SplitCol>}
            </SplitLayout>
        </Div>)
    }
}


export default FacingMonitoringStepHeader